export default "__VITE_ASSET__dac7147a__"